
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3cat/cuines",
      function () {
        return require("private-next-pages/3cat/cuines/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3cat/cuines"])
      });
    }
  